export default __webpack_public_path__ + "static/media/kast-kv.ae2312fc.jpg";